import con from '../../../../connection';
var path = '/levels';
var levels = function (url) { return function () { return ({
    get: function (param) { return con.get(url + path, param || {}); },
}); }; };
export default levels;
